<div class="fill-height d-flex bg-white" #scrollContainer>

  <article class="home-background-con">
    <img class="home-background" src="assets/images/home-bg.png" alt="background image">
  </article>

  <div *ngIf="isLoading" class="d-flex h-100 align-items-center justify-content-center">
    <mat-spinner class="zx-small-icon-size"></mat-spinner>
  </div>

  <div *ngIf="!isLoading" class="w-100 d-flex flex-column align-items-center">

    <!-- === UPPER CONTENT === -->
    <div class="w-100 d-flex row p-0 zx-min-h-none-md-100 zx-z-index-2">

      <!-- 1st CON -->
      <div class="d-flex flex-column justify-content-center col-12 col-lg-8 col-xl-7 p-2 px-sm-4 px-xl-5"
        style="min-height: 50%;">

        <!-- title -->
        <div
          class="d-flex flex-column justify-content-center pt-5 pt-sm-4 pt-md-0 main-title-width zx-z-index-2 px-4 px-lg-0 px-xl-3 flex-grow-1">
          <article class="d-flex flex-column px-sm-3 pt-sm-5">
            <!-- New question above title - only in business mode -->
            <span *ngIf="isBusinessMode" class="w-100 d-flex zx-font-heebo-medium pb-3 px-md-1 justify-content-lg-start business-unused-space-question">
              {{ 'about-us.business-unused-space-question' | translate }}
            </span>

            <!-- Make money line - only in business mode -->
            <span *ngIf="isBusinessMode" class="w-100 d-flex zx-home-t-big pb-3 px-md-1 justify-content-lg-start zx-text-pink">
              {{ 'about-us.business-make-money' | translate }}
            </span>

            <!-- 1st line -->
            <span class="d-flex align-items-end pt-1">
              <span class="zx-home-t-big">
                {{ (isBusinessMode ? 'about-us.business-main-title-1' : 'about-us.main-title-1') | translate }}
              </span>
              <span class="zx-home-t-big" style="opacity: 0;">-</span>
              <span *ngIf="typedText !== '' && typedText !== 'about-us.main-title-2.' && typedText !== 'about-us.business-title-2.'">
                <span class="zx-100-opp" style="font-size: 2px;">.</span>
                <span class="zx-home-t-device">
                  {{ typedText }}
                </span>
                <span class="zx-100-opp" style="font-size: 2px;">.</span>
              </span>
              <span class="zx-home-t-big" style="opacity: 0;">-</span>
            </span>

            <!-- 2nd line -->
            <span class="zx-home-t-big zx-main-title-3-padding" style="line-height: 43px;">
              {{ (isBusinessMode ? 'about-us.main-title-3' : 'about-us.main-title-3-home') | translate }}
            </span>

            <!-- 3rd line (new) - only in business mode -->
            <span *ngIf="isBusinessMode" class="zx-home-t-big pb-3" style="line-height: 43px;">
              {{ 'about-us.business-main-title-5' | translate }}
            </span>

            <!-- intro - long -->
            <span class="w-100 d-flex zx-font-heebo-small pb-2 pt-sm-3 pt-md-4 px-md-1">
              {{ (isBusinessMode ? 'about-us.business-explain-us-1' : 'about-us.explain-us-1') | translate }}
            </span>
            <span #businessExplainText2 class="w-100 d-flex zx-font-heebo-small px-md-1">
              {{ (isBusinessMode ? 'about-us.business-explain-us-2' : 'about-us.explain-us-2') | translate }}
            </span>

            <!-- Business form - only in business mode -->
            <div *ngIf="isBusinessMode && showBusinessForm && businessForm" 
              #businessFormContainer
              class="w-100 pt-4 px-3 px-md-4 business-form-container position-relative"
              [@expandHeight]
              [style.min-height.px]="formContainerHeight > 0 ? formContainerHeight : null">
              <!-- Success message with animation -->
              <div *ngIf="showSuccessMessage" 
                class="d-flex flex-column align-items-center justify-content-center w-100"
                style="min-height: 100%; position: absolute; top: 0; left: 0; right: 0; bottom: 0;">
                <div class="w-100 justify-content-center align-items-center position-relative d-flex flex-column">
                  <div class="business-form-success-lottie" id="businessFormSuccessAnimation"></div>
                  <p class="business-form-success-text text-center fw-bold mt-3" [class.zx-rtl]="isRTL">
                    {{ 'about-us.business-form-success-message' | translate }}
                  </p>
                </div>
              </div>
              
              <!-- Form fields - hidden when showing success -->
              <form *ngIf="!showSuccessMessage" 
                [formGroup]="businessForm" 
                (ngSubmit)="onSubmitBusinessForm()" 
                class="d-flex flex-column gap-3">
                
                <!-- Email field -->
                <mat-form-field [ngClass]="isRTL ? 'zx-rtl' : 'zx-ltr'">
                  <mat-label>{{ 'about-us.business-form-email' | translate }}</mat-label>
                  <input matInput type="email" formControlName="email" 
                    [placeholder]="'log-in-dialog-withmail-email' | translate"
                    [ngClass]="isRTL ? 'zx-rtl' : 'zx-ltr'"
                    [disabled]="isSubmittingForm">
                  <mat-error *ngIf="businessForm.get('email').invalid" 
                    [ngClass]="isRTL ? 'text-end zx-rtl' : 'text-start zx-ltr'">
                    {{ 'about-us.business-form-email-required' | translate }}
                  </mat-error>
                </mat-form-field>

                <!-- Phone field -->
                <mat-form-field [ngClass]="isRTL ? 'zx-rtl' : 'zx-ltr'">
                  <mat-label>{{ 'about-us.business-form-phone' | translate }}</mat-label>
                  <input matInput type="text" formControlName="phone" 
                    [placeholder]="'my-profile.phone' | translate"
                    [ngClass]="isRTL ? 'zx-rtl' : 'zx-ltr'" inputmode="numeric"
                    appPhoneFormatHome
                    [disabled]="isSubmittingForm">
                  <mat-error *ngIf="businessForm.get('phone').invalid" 
                    [ngClass]="isRTL ? 'text-end zx-rtl' : 'text-start zx-ltr'">
                    {{ 'about-us.business-form-phone-required' | translate }}
                  </mat-error>
                </mat-form-field>

                <!-- I am dropdown -->
                <mat-form-field [ngClass]="isRTL ? 'zx-rtl' : 'zx-ltr'">
                  <mat-label>{{ 'about-us.business-form-i-am' | translate }}</mat-label>
                  <mat-select formControlName="iAm" [ngClass]="isRTL ? 'zx-rtl' : 'zx-ltr'"
                    [disabled]="isSubmittingForm">
                    <mat-option value="business-owner">{{ 'about-us.business-form-i-am-business-owner' | translate }}</mat-option>
                    <mat-option value="student">{{ 'about-us.business-form-i-am-student' | translate }}</mat-option>
                    <mat-option value="other">{{ 'about-us.business-form-i-am-other' | translate }}</mat-option>
                  </mat-select>
                  <mat-error *ngIf="businessForm.get('iAm').invalid" 
                    [ngClass]="isRTL ? 'text-end zx-rtl' : 'text-start zx-ltr'">
                    {{ 'about-us.business-form-i-am-required' | translate }}
                  </mat-error>
                </mat-form-field>

                <!-- I am other text field - only if "other" is selected -->
                <mat-form-field *ngIf="businessForm.get('iAm').value === 'other'" [ngClass]="isRTL ? 'zx-rtl' : 'zx-ltr'">
                  <mat-label>{{ 'about-us.business-form-i-am-other-text' | translate }}</mat-label>
                  <input matInput type="text" formControlName="iAmOtherText" 
                    [placeholder]="'about-us.business-form-i-am-other-text' | translate"
                    [ngClass]="isRTL ? 'zx-rtl' : 'zx-ltr'"
                    [disabled]="isSubmittingForm">
                  <mat-error *ngIf="businessForm.get('iAmOtherText').invalid" 
                    [ngClass]="isRTL ? 'text-end zx-rtl' : 'text-start zx-ltr'">
                    {{ 'about-us.business-form-i-am-other-text-required' | translate }}
                  </mat-error>
                </mat-form-field>

                <!-- About you textarea -->
                <mat-form-field [ngClass]="isRTL ? 'zx-rtl' : 'zx-ltr'">
                  <mat-label>{{ 'about-us.business-form-about-you' | translate }}</mat-label>
                  <textarea matInput formControlName="aboutYou" rows="4" 
                    [placeholder]="'about-us.business-form-about-you' | translate"
                    [ngClass]="isRTL ? 'zx-rtl' : 'zx-ltr'"
                    [disabled]="isSubmittingForm"></textarea>
                  <mat-error *ngIf="businessForm.get('aboutYou').invalid" 
                    [ngClass]="isRTL ? 'text-end zx-rtl' : 'text-start zx-ltr'">
                    {{ 'about-us.business-form-about-you-required' | translate }}
                  </mat-error>
                </mat-form-field>
              </form>
            </div>

            <!-- try it brn -->
            <div class="pt-5 pb-md-5 w-100 d-flex flex-column align-items-center">
              <div class="w-100 d-flex justify-content-center position-relative">
                <!-- Close button X - at the edge, next to submit button -->
                <button *ngIf="isBusinessMode && showBusinessForm && businessForm && !showSuccessMessage" 
                  type="button" 
                  class="business-form-close-btn"
                  [class.business-form-close-btn-rtl]="isRTL"
                  [class.business-form-close-btn-ltr]="!isRTL"
                  (click)="toggleBusinessForm()"
                  mat-icon-button
                  [disabled]="isSubmittingForm">
                  <mat-icon class="business-form-close-icon">close</mat-icon>
                </button>
                <button *ngIf="!isBusinessMode || !showBusinessForm" mat-stroked-button
                  class="rounded-pill try-now-btn zx-border-dark zx-text-tiny zx-text-sm-small zx-home-hover-effect"
                  (click)="isBusinessMode ? toggleBusinessForm() : goHome()">
                  {{ (isBusinessMode ? 'about-us.business-apply-button' : 'q-and-a.1.btn-try') | translate }}
                </button>
                <button *ngIf="isBusinessMode && showBusinessForm && businessForm && !showSuccessMessage" mat-stroked-button
                  class="rounded-pill try-now-btn zx-border-dark zx-text-tiny zx-text-sm-small zx-home-hover-effect d-flex align-items-center justify-content-center gap-2"
                  type="button"
                  (click)="onSubmitBusinessForm()"
                  [disabled]="isSubmittingForm">
                  <mat-spinner *ngIf="isSubmittingForm" 
                    [diameter]="20" 
                    [strokeWidth]="3"
                    class="business-form-button-spinner"></mat-spinner>
                  <span *ngIf="!isSubmittingForm">{{ 'about-us.business-form-submit' | translate }}</span>
                </button>
              </div>
              
              <!-- Fields not complete message -->
              <div *ngIf="showFieldsNotCompleteMessage" 
                class="business-form-fields-not-complete-message w-100 d-flex justify-content-center pt-2">
                <span class="zx-font-heebo-small zx-text-pink">
                  {{ 'about-us.business-form-fields-not-complete' | translate }}
                </span>
              </div>
            </div>

            <span
              class="w-100 d-flex zx-font-heebo-medium px-md-1 pt-5 pt-md-3 justify-content-center justify-content-lg-start">
              {{ (isBusinessMode ? 'about-us.how-to-print' : 'about-us.how-it-works') | translate }}
            </span>
          </article>
        </div>
        <!-- // title -->

        <!-- under title -->
        <div class="d-flex flex-column main-title-width zx-z-index-2 flex-grow-1 px-3 pt-4">
          <article class="d-flex row px-md-5 position-relative">
            <div *ngFor="let step of getSteps(); let last = last"
              class="col-12 p-2 d-flex justify-content-center zx-z-index-2 zx-home-hover-effect"
              [class.step-home-item-last]="last">
              <div class="step-home-item d-flex align-items-center rounded-2 gap-3 p-3 px-md-4 mb-5">
                <div class="d-flex justify-content-center align-items-center">
                  <div [class]="'steps-icon-' + step.color"
                    class="d-flex justify-content-center align-items-center p-2">
                    <mat-icon class="text-white" style="font-size: 32px; width: 32px; height: 32px;">
                      {{ step.icon }}
                    </mat-icon>
                  </div>
                </div>
                <div class="d-flex flex-column gap-1">
                  <b [class]="'zx-font-heebo-medium-' + step.color">
                    {{ "about-us.main-" + step.index | translate }}
                  </b>
                  <span class="zx-font-heebo-small">
                    {{ "about-us.main-explain-" + step.index | translate }}
                  </span>
                </div>
              </div>
            </div>
            <div class="w-100 h-100 position-absolute top-0 start-0 pt-5 d-flex justify-content-center"
              style="padding-bottom: 80px;">
              <span class="vertical-pulse-line"></span>
            </div>
          </article>

          <!-- try it brn -->
          <div class="d-flex w-100 justify-content-center zx-z-index-2" style="transform: translateY(-35px);">
            <button mat-stroked-button
              class="rounded-pill try-now-btn try-now-btn-green zx-border-dark zx-text-tiny zx-text-sm-small zx-home-hover-effect"
              (click)="goHome()">
              {{ (isBusinessMode ? "about-us.find-station" : "about-us.find-station") | translate }}
            </button>
          </div>

        </div>
        <!-- // under title -->

      </div>
      <!-- // 1st CON -->

      <!-- 2nd CON -->
      <div
        class="d-flex flex-column justify-content-sm-center col-12 col-lg-4 col-xl-5 p-0 zx-min-h-services zx-z-index-2"
        (mouseenter)="onServiceHover(imgService)" (mouseleave)="onServiceLeave()">

        <!-- === second container === -->
        <div class="w-100 d-flex flex-column" style="max-height: 100vh;">

          <!-- service IMAGE -->
          <div
            class="d-flex justify-content-center align-items-center p-0 position-relative w-100 zx-min-h-100-md-none">
            <div *ngFor="let service of services; let i = index" class="slide-image-con h-100"
              [class.zx-home-image-con-top]="!isScreenWide && serviceExplainText.length > 0"
              [class.slide-image-con-not-rtl]="!isRTL">
              <span *ngIf="service === imgService" class="d-flex flex-column gap-2 zx-home-service-con zx-z-index-10"
                [class.zx-home-service-con-hover]="hoverService !== ''">
                <span class="zx-font-heebo-medium-pink">
                  {{ "about-us.station-" + service | translate }}
                </span>
                <span class="zx-font-heebo-small">
                  {{ "about-us.station-exp-" + service | translate }}
                </span>
                <a *ngIf="serviceExplainText.length === 0"
                  class="zx-font-heebo-small opacity-75 text-green d-lg-none zx-z-index-10 c-pointer"
                  (click)="onServiceHover(service, true)">
                  {{ "collect.more-info" | translate }}...
                </a>
                <span *ngIf="hoverService !== ''" class="zx-font-heebo-small">
                  {{ serviceExplainText }}
                </span>
                <a *ngIf="isServiceExplainTextCompleted && !isScreenWide"
                  class="zx-font-heebo-small opacity-75 text-green c-pointer" (click)="onServiceLeave(true)">
                  {{ "my-orders.hide" | translate }}...
                </a>
                <!-- try it brn -->
                <div class="d-flex zx-z-index-2 zx-home-hover-effect"
                  *ngIf="hoverService !== '' && serviceExplainText.length === completeServiceExplainText.length">
                  <button *ngIf="!isBusinessMode" mat-stroked-button
                    class="rounded-pill try-now-btn zx-border-dark zx-text-tiny zx-text-sm-small zx-try-btn-down"
                    [class.zx-try-btn-down]="!isServiceExplainTextCompleted"
                    [class.zx-try-btn-up]="isServiceExplainTextCompleted" (click)="goHome()">
                    {{ "q-and-a.1.btn-try" | translate }}
                  </button>
                  <button *ngIf="isBusinessMode" mat-stroked-button
                    class="rounded-pill try-now-btn zx-border-dark zx-text-tiny zx-text-sm-small zx-try-btn-down"
                    [class.zx-try-btn-down]="!isServiceExplainTextCompleted"
                    [class.zx-try-btn-up]="isServiceExplainTextCompleted" 
                    (click)="scrollToTopAndOpenForm()">
                    {{ "about-us.business-apply-button" | translate }}
                  </button>
                </div>
              </span>
              <img [@slideInOut]="service === imgService ? 'in' : 'out'"
                [class.zx-home-img-con-top]="!(!isScreenWide && serviceExplainText.length > 0)"
                [class.zx-home-img-con-top-explain]="!isScreenWide && serviceExplainText.length > 0"
                [src]="'assets/images/home-media/station-' + service + '.png'" alt="Eazix App Image"
                class="slide-image">
            </div>
          </div>
          <!-- // service IMAGE -->

        </div>
        <!-- // === second container === -->

      </div>
      <!-- // 2nd CON -->

    </div>
    <!-- // === UPPER CONTENT === -->

    <!-- === LOWWER - 1 CONTENT === -->
    <!-- 3nd CON -->
    <span class="d-lg-none" style="height: 40px;"></span>

    <!-- === MAP + credits container === -->
    <div class="w-100 d-flex row p-0 h-lg-100"
      [class.zx-home-map-con-top]="!(!isScreenWide && serviceExplainText.length > 0)"
      [class.zx-home-map-con-top-explain]="!isScreenWide && serviceExplainText.length > 0">

      <!-- === credits container === -->
      <div class="d-flex col-12 col-md-7 col-lg-6 col-xl-5 flex-column col-12 zx-z-index-2 px-sm-5 px-md-3 pt-2 pt-sm-0"
        style="height: 520px;">

        <div class="w-100 d-flex flex-column zx-p-t-down-con pt-3 p-md-4 pt-lg-0 h-100">

          <span
            class="w-100 d-flex zx-font-heebo-medium px-md-1 pb-3 pt-md-3 pt-lg-0 justify-content-center justify-content-lg-start px-2">
            {{ "about-us.why-eazix" | translate }}?
          </span>

          <div class="d-flex flex-grow-1 flex-column gap-4 justify-content-center align-items-center">
            <div *ngFor="let ad of getAdvantages()" class="col-12 px-2 d-flex zx-z-index-2 zx-home-hover-effect">
              <div class="d-flex align-items-center rounded-2 gap-4">
                <div class="d-flex justify-content-center align-items-center">
                  <img [src]="'assets/images/home-media/' + ad.name + '.svg'" [alt]="ad.name"
                    style="width: 55px; height: 55px;">
                </div>
                <div class="d-flex flex-column gap-1">
                  <b [class]="'zx-font-heebo-medium-' + ad.color">
                    {{ "about-us.ad." + ad.name | translate }}
                  </b>
                  <span class="zx-font-heebo-small">
                    {{ "about-us.ad-exp." + ad.name | translate }}
                  </span>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
      <!-- === credits container === -->

      <!-- === MAP + credits container === -->
      <div class="d-flex col-12 col-md-5 col-lg-6 col-xl-7 flex-column col-12 zx-z-index-2 px-lg-3 pt-2 pt-sm-0"
        style="height: 520px;" [class.zx-home-image-con-top]="!isScreenWide && serviceExplainText.length > 0">

        <div class="w-100 d-flex flex-column zx-p-t-down-con p-3 p-md-4 pt-lg-0 h-100">

          <span
            class="w-100 d-flex zx-font-heebo-medium px-md-1 pb-3 pt-md-3 pt-lg-0 justify-content-center justify-content-lg-start px-2">
            {{ "about-us.stations-map" | translate }}?
          </span>

          <!-- GOOGLE MAP -->
          <div class="d-flex flex-grow-1 justify-content-center align-items-center px-2 px-sm-0">
            <div id="map" class="w-100 h-100" style="border-radius: 5px; overflow: hidden;"></div>
            <!-- // =-= back to list =-= -->
            <div class="d-flex d-md-none p-2 position-absolute bottom-0" [class.stick-to-right]="isRTL"
              [class.stick-to-left]="!isRTL">
            </div>
            <!-- // =-= back to list =-= -->
          </div>
          <!-- // GOOGLE MAP -->

        </div>
      </div>
      <!-- === MAP + credits container === -->

      <!-- === MAP + credits container === -->
      <div class="d-flex col-12">

        <div class="w-100 d-flex justify-content-between align-items-center p-2 p-md-4 zx-z-index-2 pb-4">

          <button *ngIf="!isBusinessMode" mat-stroked-button class="rounded-pill try-now-btn zx-border-dark zx-text-tiny zx-text-sm-small"
            (click)="goHome()">
            {{ "q-and-a.1.btn-try" | translate }}
          </button>
          <button *ngIf="isBusinessMode" mat-stroked-button class="rounded-pill try-now-btn zx-border-dark zx-text-tiny zx-text-sm-small business-apply-button-bottom"
            (click)="scrollToTopAndOpenForm()">
            {{ "about-us.business-apply-button" | translate }}
          </button>

          <div class="d-flex justify-content-center align-items-center gap-3 px-sm-2 px-md-4">
            <span class="d-none d-sm-inline zx-font-heebo-small">
              <span>
                {{ "about-us.follow-us" | translate }}
              </span>
            </span>
            <div class="zx-medium-small-icon-size zx-home-hover-effect c-pointer" (click)="goToFB()">
              <img src="assets/images/fb-icon.svg" alt="Facebook Logo" class="svg w-100 h-100">
            </div>
            <div class="zx-medium-small-icon-size zx-home-hover-effect c-pointer" (click)="goToInstagram()">
              <img src="assets/images/instagram-icon.svg" alt="Instagram Logo" class="svg w-100 h-100">
            </div>
          </div>

          <div class="d-flex justify-content-center align-items-center gap-3 px-sm-2 px-md-4 c-pointer" (click)="openWhatsApp()">
            <span *ngIf="!isBusinessMode" class="d-none d-sm-inline zx-font-heebo-small">
              <span>
                {{ "main-nav.contact-us" | translate }}
              </span>
            </span>
            <span *ngIf="isBusinessMode" class="d-none d-md-inline zx-font-heebo-small">
              <span>
                {{ "main-nav.contact-us" | translate }}
              </span>
            </span>
            <div class="whatsup-logo-container-small zx-medium-small-icon-size zx-home-hover-effect">
              <img src="assets/images/whatsup-logo.svg" alt="WhatsUp Logo" class="whatsup-logo-small">
            </div>
          </div>

        </div>
      </div>
      <!-- === MAP + credits container === -->

    </div>
    <!-- === MAP + container === -->

  </div>
</div>